import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProjectDetail from "../pages/project-detail/page";
import ProjectsPage from "../pages/projects/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/projeler",
    element: <ProjectsPage />,
  },
  {
    path: "/projeler/:id",
    element: <ProjectDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
